import React from 'react';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import CommissionCover from './CommissionCover';
import { getDeviationTitle } from '../../_helpers';
import s from './Commission.scss';
export var CommissionFullView = function (_a) {
    var deviation = _a.deviation;
    var deviationTitle = getDeviationTitle(deviation);
    return (React.createElement("div", { className: s['root'] },
        React.createElement(CentralColumn, null,
            React.createElement(CommissionCover, { deviation: deviation }),
            React.createElement("h1", { className: s['header'] }, deviationTitle))));
};
CommissionFullView.displayName = 'CommissionFullView';
export default CommissionFullView;
//# sourceMappingURL=Commission.js.map